module.exports = __webpack_public_path__ + "img/QRcode.fe415263.jpeg";